import request from '@/utils/request'

let ReviewApi = {
  /*获取设置*/
  getSetting(data, errorback) {
    return request._get('/shop/user.Review/index', data, errorback);
  },
  /*保存设置*/
  saveSetting(data, errorback) {
    return request._post('/shop/user.Review/edit', data, errorback);
  },
  /*申请列表*/
  getList(data, errorback) {
    return request._post('/shop/user.Review/getList', data, errorback);
  },
  /*申请列表*/
  editStatus(data, errorback) {
    return request._post('/shop/user.Review/editStatus', data, errorback);
  },
}
export default ReviewApi;



// WEBPACK FOOTER //
// ./src/api/review.js